

export function stringifyPrice(price: number | string): string{
    return `${price}$`;
}